export default {
	data() {
		return {
            projectFinanceTabSwitch: 'conditions'
		};
	}
};
